var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-header__menu-wrap"},[_c('HeadMenu',{attrs:{"menu":1,"menuClass":'header-menu'}}),_c('HeadMenu',{attrs:{"menu":2,"menuClass":'main-menu'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }